import { NgModule } from '@angular/core';
import { ActiveDirective } from './active.class';
import { EqualValidatorDirective } from './equal-validator.directive';
import { InputValidateDirective } from './input-validate.directive';
var ActiveModule = (function () {
    function ActiveModule() {
    }
    ActiveModule.forRoot = function () {
        return { ngModule: ActiveModule, providers: [] };
    };
    return ActiveModule;
}());
export { ActiveModule };
ActiveModule.decorators = [
    { type: NgModule, args: [{
                declarations: [ActiveDirective, EqualValidatorDirective, InputValidateDirective],
                exports: [ActiveDirective, EqualValidatorDirective, InputValidateDirective]
            },] },
];
/** @nocollapse */
ActiveModule.ctorParameters = function () { return []; };
//# sourceMappingURL=active.module.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/inputs/active.module.js
// module id = ../../../../angular-bootstrap-md/inputs/active.module.js
// module chunks = 3